import {useRoute} from '@react-navigation/native';
import AssessmentDetails from '@/Screens/Assessments/components/AssessmentDetails';

export default function AssessmentReport({dashboardData, modifyMainMenu}) {
  const route = useRoute();
  const assessmentId = route.params?.id;
  // const openingGamePercentage = route.params?.openingGamePercentage;
  // const middleGamePercentage = route.params?.middleGamePercentage;
  // const endGamePercentage = route.params?.endGamePercentage;
  // const calculationDepthPercentage = route.params?.calculationDepthPercentage;
  const cdcUsername = dashboardData.user.cdc_name;
  const licUsername = dashboardData.user.lic_name;
  const onboardingStatus = dashboardData.user.learning_onboarding_status;
  const firstAssessmentPending = dashboardData.user.first_assessment_pending;

  return (
    <AssessmentDetails
      handleBack={() => {}}
      assessmentId={assessmentId}
      // openingGamePercentage={Number(openingGamePercentage).toFixed(2)}
      // middleGamePercentage={Number(middleGamePercentage).toFixed(2)}
      // endGamePercentage={Number(endGamePercentage).toFixed(2)}
      // calculationDepthPercentage={Number(calculationDepthPercentage).toFixed(2)}
      onboardingStatus={onboardingStatus}
      firstAssessmentPending={firstAssessmentPending}
      cdcUsername={cdcUsername}
      licUsername={licUsername}
      modifyMainMenu={modifyMainMenu}
    />
  );
}
